import { getToggleableStyles } from '../toggleable-styles';

export const getAccountBreadcrumbStyles = (_, { palette = {} }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#2F2F2F',
    marginLeft: 8,
    '& .accounts-dropdown.dropdown': {
      height: 60,
    },
  },
  ...getToggleableStyles(palette),
  dropdownToggle: {
    height: 60,
    color: '#ffffff',
    backgroundColor: '#2F2F2F !important',
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    border: 'none',
    borderRadius: 0,
  },
  dropdownToggleWidthXLarge: {
    width: 75,
    minWidth: '75px !important',
  },
  dropdownToggleWidthLarge: {
    width: 36,
    minWidth: '36px !important',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
  },
  headerReadOnly: {
    color: '#ffffff',
  },
  bulletedTreeListLarge: {
    fontSize: '20px !important',
    lineHeight: '20px !important',
  },
  bulletedTreeListXLarge: {
    fontSize: '16px !important',
    lineHeight: '16px !important',
  },
  headerTextXLarge: {
    fontSize: '14px',
    lineHeight: '14px',
    fontWeight: 'normal',
    paddingTop: '6px',
  },
  entity: {
  },
  topLine: {
    paddingTop: 8,
    paddingRight: 8,
    paddingLeft: 8,
    paddingBottom: 2,
    minHeight: 30,
  },
  topLeftText: {
    color: 'inherit',
    fontSize: '14px',
    lineHeight: '14px',
    fontWeight: 'normal',
    height: '20px',
    float: 'left',
    maxWidth: 240,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  topChevronRight: {
    float: 'left',
    fontSize: '12px !important',
    lineHeight: '12px !important',
    margin: '0 !important',
    top: '0 !important',
    paddingLeft: 6,
    paddingRight: 6,
    paddingTop: 2,
  },
  topRightText: {
    color: 'inherit',
    fontSize: '14px',
    lineHeight: '14px',
    fontWeight: 600,
    height: '20px',
    float: 'left',
  },
  bottomLine: {
    minHeight: 30,
    paddingBottom: 8,
    paddingRight: 8,
    paddingLeft: 8,
    display: 'flex',
  },
  bottomText: {
    float: 'left',
    display: 'flex',
    marginRight: 'auto',
    alignItems: 'baseline',
  },
  bottomLeftText: {
    color: 'inherit',
    fontSize: 14,
    fontWeight: 600,
  },
  bottomRightText: {
    color: 'inherit',
    fontSize: 10,
    fontWeight: 'normal',
    paddingLeft: 4,
    maxWidth: 130,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  bottomChevronDown: {
    color: 'inherit',
    margin: '0 !important',
    top: '0 !important',
    fontSize: '12px !important',
    lineHeight: '12px !important',
    paddingBottom: 3,
    paddingTop: 7,
    paddingLeft: 8,
  },
  dropdownMenu: {
    minWidth: '468px',
    '& .customer-hierarchy-tree': {
      minHeight: '50px',
      maxHeight: '450px',
      overflowY: 'auto',
      overflowX: 'hidden',
      '& .tree-node:hover': {
        backgroundColor: palette.neutralLight,
      },
    },
    '& .ba-breadcrumbs': {
      '& .breadcrumb': {
        marginBottom: '0px',
        backgroundColor: 'inherit',
        minHeight: '56px',
        padding: '15px 15px',
        '& .breadcrumb-anchor': {
          wordBreak: 'break-all',
        },
      },
      '& .breadcrumb li a': {
        fontSize: '14px',
        color: palette.neutralSecondary,
        lineHeight: '24px',
      },
      '& .breadcrumb > li + li:before': {
        content: '"\\E76C"',
        fontFamily: 'MsAds MDL2 Assets',
        fontSize: '12px',
        color: palette.neutralSecondary,
      },
      '& .breadcrumb li:last-child a': {
        color: palette.neutralPrimary,
        fontWeight: 'bold',
      },
    },
    '& .switch-accounts': {
      marginBottom: '6px',
      marginLeft: '15px',
      color: palette.themePrimary,
      cursor: 'pointer',
    },
    '& .toggle-showinactive-accounts': {
      paddingLeft: '20px',
      borderTop: `1px solid ${palette.neutralLighter}`,
    },
    '& .search-box__input-group': {
      borderTop: `1px solid ${palette.neutralLighter}`,
      borderBottom: `1px solid ${palette.neutralLighter}`,
      height: '48px',
      display: 'flex',
      '& .search-box__icon:before': {
        content: '"\\E721"',
        fontFamily: 'MsAds MDL2 Assets',
        fontSize: '16px',
        color: palette.themePrimary,
      },
      '& .search-box__icon': {
        marginLeft: '-445px',
        marginTop: '10px',
        marginBottom: '10px',
        padding: '6px 0px',
        outline: 'none',
        lineHeight: '16px',
        '&:focus': {
          border: '2px solid black',
          borderRadius: '5px',
          marginTop: '8px',
          marginLeft: '-447px',
        },
      },
      '& .search-box__input': {
        alignSelf: 'center',
        paddingLeft: '48px',
        border: 'none',
      },
    },
    '& .title-span': {
      color: palette.neutralPrimary,
      padding: '6px 16px',
      lineHeight: '20px',
      display: 'block',
      fontWeight: 'bold',
      marginBottom: '4px',
    },
    '& .current-node': {
      backgroundColor: palette.neutralLight,
      '& .text-span': {
        fontWeight: 'bold',
      },
      '& .gray-out-text-span': {
        color: '#797775',
      },
    },
    '& .tree-node': {
      '& > span': {
        margin: '8px 16px',
        lineHeight: '18px',
        color: palette.neutralPrimary,
        display: 'flex',
        alignItems: 'center',
        '& > span:last-child': {
          flexGrow: 1,
        },
        '& .tree-node-content': {
          display: 'flex',
          alignItems: 'center',
          flexGrow: 1,
          justifyContent: 'space-between',
          '& [class^="global-menu-toolbar-menu-item-callout-click"]': {
            display: 'flex',
            '& div': {
              maxWidth: 300,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
          },
        },
      },
      '& .text-span': {
        cursor: 'pointer',
        maxWidth: 300,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      '& a span': {
        color: palette.neutralPrimary,
      },
      '& .gray-out-text-span': {
        color: '#797775',
      },
      '& .grid-expanded-icon:before': {
        content: '"\\E70D"',
        fontFamily: 'MsAds MDL2 Assets',
        fontSize: '12px',
        color: palette.neutralSecondary,
        marginRight: '8px',
        marginTop: '2px',
      },
      '& .grid-expand-icon:before': {
        content: '"\\E76C"',
        fontFamily: 'MsAds MDL2 Assets',
        fontSize: '12px',
        color: palette.neutralSecondary,
        marginRight: '8px',
        marginTop: '2px',
      },
    },
  },
});
